import React from "react";

export default function UserView() {
  return (
    <div>
      <p>UserView</p>
    </div>
  );
}
